module.exports = __webpack_public_path__ + "static/media/liquid_22_detail_07.778a9365.jpg";